import React from 'react';
import { useParams } from 'react-router-dom';
import MarkdownViewer from '@components/common/MarkdownViewer.jsx';

const DocsPage = () => {
  const { docId } = useParams();

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-7xl mx-auto py-8">
        <MarkdownViewer filePath={docId} />
      </div>
    </div>
  );
};

export default DocsPage;
